import { render } from "./InlineTextLoader.vue?vue&type=template&id=28f00a34&scoped=true&ts=true"
import script from "./InlineTextLoader.vue?vue&type=script&lang=ts"
export * from "./InlineTextLoader.vue?vue&type=script&lang=ts"

import "./InlineTextLoader.vue?vue&type=style&index=0&id=28f00a34&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28f00a34"]])

export default __exports__